import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { PowerOff, Power, AlertTriangle } from 'lucide-react';
import { adminEnquetesAPI } from '../../utils/adminEnquetesAPI';
import { sucessoComHorario } from '../../utils/toastComHorario';
import ModalRodape from './ModalRodape';

// Conteúdo compartilhado pelos dois modais de confirmação de
// desativar/reativar enquete — nunca existe exclusão definitiva aqui (isso
// já é papel do soft-delete que perguntas/opções usam); desativar só tira a
// enquete de circulação (lista principal + acesso público) sem apagar nada,
// e reativar desfaz isso a qualquer momento.
const ConfirmarStatusEnqueteModal = ({ enquete, acao, onFechar, onConfirmado }) => {
  const [enviando, setEnviando] = useState(false);
  const desativando = acao === 'desativar';

  const confirmar = async () => {
    setEnviando(true);
    try {
      if (desativando) {
        await adminEnquetesAPI.desativar(enquete.id);
        sucessoComHorario(`"${enquete.titulo}" desativada`);
      } else {
        await adminEnquetesAPI.reativar(enquete.id);
        sucessoComHorario(`"${enquete.titulo}" reativada`);
      }
      onConfirmado();
      onFechar();
    } catch (error) {
      toast.error(error.userMessage || 'Erro ao atualizar a enquete');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="space-y-4">
      <div className={`flex items-start gap-3 rounded-xl p-4 ${desativando ? 'bg-amber-50' : 'bg-emerald-50'}`}>
        {desativando ? (
          <PowerOff className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
        ) : (
          <Power className="w-5 h-5 text-emerald-600 flex-shrink-0 mt-0.5" />
        )}
        <div className="text-sm">
          <p className="font-medium text-gray-900">"{enquete.titulo}"</p>
          {desativando ? (
            <p className="text-gray-600 mt-1">
              Sai da listagem principal e do acesso público imediatamente, volta como privada e o status volta pra "rascunho". Nada é apagado — dá pra reativar quando quiser, na seção "Enquetes Desativadas".
            </p>
          ) : (
            <p className="text-gray-600 mt-1">
              Volta pra listagem principal como privada e com status "rascunho" — pra ficar pública de novo, primeiro mude o status em "Configurar" pra "Publicada" ou "Encerrada".
            </p>
          )}
        </div>
      </div>

      {desativando && enquete.visibilidade === 'publica' && (
        <div className="flex items-start gap-2 text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2">
          <AlertTriangle className="w-3.5 h-3.5 flex-shrink-0 mt-0.5" />
          Essa enquete está pública agora — desativar corta o acesso de quem já tem o link direto e a torna privada automaticamente.
        </div>
      )}

      <ModalRodape>
        <button
          onClick={onFechar}
          className="text-sm font-medium text-gray-600 hover:bg-gray-100 rounded-lg px-4 py-2.5 transition-colors"
        >
          Cancelar
        </button>
        <button
          onClick={confirmar}
          disabled={enviando}
          className={`font-medium text-sm px-4 py-2.5 rounded-lg transition-colors disabled:opacity-50 ${
            desativando
              ? 'bg-amber-600 hover:bg-amber-700 text-white'
              : 'bg-emerald-600 hover:bg-emerald-700 text-white'
          }`}
        >
          {enviando ? 'Aguarde...' : desativando ? 'Desativar' : 'Reativar'}
        </button>
      </ModalRodape>
    </div>
  );
};

export default ConfirmarStatusEnqueteModal;
